module.exports = __webpack_public_path__ + "img/redes-icono-instagram.82bf950b.svg";